import { render, staticRenderFns } from "./ResultCompatibiliteV.vue?vue&type=template&id=1f22cb7e&"
import script from "./ResultCompatibiliteV.vue?vue&type=script&lang=js&"
export * from "./ResultCompatibiliteV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports